export default __webpack_public_path__ + "static/media/Portrait.e6112a77.png";